import { render } from "./IndependentClock.vue?vue&type=template&id=606134e6"
import script from "./IndependentClock.vue?vue&type=script&lang=js"
export * from "./IndependentClock.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__